import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function ProfileHero() {
  return (
    <div className="bg-primary-dark px-5 pt-12 pb-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-4">
          <div className="relative">
            <div className="w-16 h-16 rounded-full overflow-hidden border-3 border-gold">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1c14eb59c-1772756126505.png"
                alt="Ayşe Kaya profil fotoğrafı — genç kadın gülümsüyor"
                width={64}
                height={64}
                className="w-full h-full object-cover" />
              
            </div>
            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-gold rounded-full border-2 border-primary-dark flex items-center justify-center">
              <Icon name="StarIcon" size={10} variant="solid" className="text-white" />
            </div>
          </div>
          <div>
            <h1 className="text-white font-bold text-xl">Ayşe Kaya</h1>
            <p className="text-white/60 text-sm">ayse.kaya@gmail.com</p>
            <div className="flex items-center gap-2 mt-1">
              <span className="bg-gold/20 border border-gold/40 text-gold text-xs font-bold px-2 py-0.5 rounded-full">
                Altın Üye ★
              </span>
            </div>
          </div>
        </div>
        <button className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
          <Icon name="PencilIcon" size={16} className="text-white" />
        </button>
      </div>

      {/* Barista link */}
      <Link
        href="/barista-dashboard"
        className="flex items-center gap-2 bg-white/10 rounded-xl px-4 py-2.5 border border-white/20 hover:bg-white/20 transition-colors">
        
        <Icon name="ClipboardDocumentListIcon" size={18} className="text-gold" />
        <span className="text-white text-sm font-semibold">Barista Ekranına Geç</span>
        <Icon name="ChevronRightIcon" size={16} className="text-white/50 ml-auto" />
      </Link>
    </div>);

}